import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceRental {
    lookupService = new APIServiceLookUp();

    async addRental(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}rental/addRental`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async deleteRental(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}rental/deleteRental`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateRental(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}rental/updateRental`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async getAllRental(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}rental/getAllRental`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }
}